var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTimecards = function SvgTimecards(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73.861,
    height: 80,
    viewBox: "0 0 73.861 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_date_picker_gorr",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M307.923,215.937H240.854a1.2,1.2,0,0,1-1.2-1.2V141.585a1.2,1.2,0,0,1,1.2-1.2h67.069a1.2,1.2,0,0,1,1.2,1.2v73.152A1.2,1.2,0,0,1,307.923,215.937Zm-67.069-75.073a.721.721,0,0,0-.72.72v73.152a.721.721,0,0,0,.72.72h67.069a.721.721,0,0,0,.72-.72V141.585a.721.721,0,0,0-.72-.72Z",
    transform: "translate(-235.263 -135.937)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(17.855 28.563)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_292",
    "data-name": "Ellipse 292",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(24.42 28.563)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(30.985 28.563)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_294",
    "data-name": "Ellipse 294",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(37.55 28.563)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_295",
    "data-name": "Ellipse 295",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(44.115 28.563)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_296",
    "data-name": "Ellipse 296",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(50.68 28.563)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(57.244 28.563)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(17.855 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_299",
    "data-name": "Ellipse 299",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(24.42 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_300",
    "data-name": "Ellipse 300",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(30.985 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(37.55 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302",
    "data-name": "Ellipse 302",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(44.115 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_303",
    "data-name": "Ellipse 303",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(50.68 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(57.244 33.552)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(17.855 38.542)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_306",
    "data-name": "Ellipse 306",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(24.42 38.542)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(30.985 38.542)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(37.55 38.542)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(44.115 38.542)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(50.68 38.542)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(57.244 38.542)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(17.855 43.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(24.42 43.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(17.855 48.52)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(24.42 48.52)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(30.985 48.52)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_317",
    "data-name": "Ellipse 317",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(30.985 43.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_318",
    "data-name": "Ellipse 318",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(37.55 43.531)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_319",
    "data-name": "Ellipse 319",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(44.115 43.531)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(50.68 43.531)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 1.576,
    cy: 1.576,
    r: 1.576,
    transform: "translate(57.244 43.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M377.147,213.882a.952.952,0,1,0,0,1.9h23.864a.952.952,0,1,0,.031-1.9h-23.9Z",
    transform: "translate(-349.949 -197.67)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M557.869,211.939a.187.187,0,0,0,0,.265l.8.8h-1.983a.187.187,0,1,0,0,.375h1.983l-.8.8a.187.187,0,0,0,.265.265l1.124-1.124a.187.187,0,0,0,0-.265l-1.124-1.124A.187.187,0,0,0,557.869,211.939Z",
    transform: "translate(-501.395 -195.992)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M340.7,211.939a.187.187,0,0,1,0,.265l-.8.8h1.983a.187.187,0,1,1,0,.375h-1.983l.8.8a.187.187,0,0,1-.265.265l-1.124-1.124a.187.187,0,0,1,0-.265l1.124-1.124A.187.187,0,0,1,340.7,211.939Z",
    transform: "translate(-318.919 -195.992)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M355.9,498.231a3.414,3.414,0,0,0,0,6.828h26.522a3.414,3.414,0,0,0,0-6.828Z",
    transform: "translate(-330.031 -436.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M217.714,123.576a5.486,5.486,0,1,1,5.486-5.486A5.486,5.486,0,0,1,217.714,123.576Z",
    transform: "translate(-212.227 -112.604)",
    fill: "#00bfa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M234.467,132.137h-1.623v-1.623a.541.541,0,1,0-1.082,0v1.623h-1.624a.541.541,0,0,0,0,1.082h1.624v1.623a.541.541,0,1,0,1.082,0v-1.623h1.623a.541.541,0,0,0,0-1.082Z",
    transform: "translate(-226.816 -127.192)",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimecards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timecards.a8e7f06d.svg";
export { ForwardRef as ReactComponent };